(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dr-search-panel"] && !Shopify.designMode) return;
  try {
    (function() {
  var root      = document.querySelector('[data-dr-search]');
  var toggle    = document.querySelector('[data-search-toggle]');
  var input     = root && root.querySelector('[data-dr-search-input]');
  var backdrop  = root && root.querySelector('[data-dr-search-backdrop]');
  var closeBtn  = root && root.querySelector('[data-dr-search-close]');
  var emptyEl   = root && root.querySelector('[data-dr-search-empty]');
  var liveEl    = root && root.querySelector('[data-dr-search-live]');
  var chips     = root ? root.querySelectorAll('[data-dr-search-chip]') : [];
  if (!root || !toggle || !input || !liveEl) return;

  var TRANSITION_MS = 220;  // must match .dr-search__panel transition duration in CSS above

  // ---- Open/close ----
  function open() {
    root.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function() { root.setAttribute('data-open', ''); });
    setTimeout(function() { input.focus(); input.select(); }, 50);
  }
  function close() {
    root.removeAttribute('data-open');
    toggle.setAttribute('aria-expanded', 'false');
    setTimeout(function() {
      root.hidden = true;
      if (document.activeElement && root.contains(document.activeElement)) {
        toggle.focus();
      }
    }, TRANSITION_MS);
  }
  toggle.addEventListener('click', function(e) { e.preventDefault(); open(); });
  backdrop.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !root.hidden) {
      if (input.value) { input.value = ''; renderEmpty(); }
      else close();
    }
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      root.hidden ? open() : close();
    }
  });

  // ---- Chips fill the input and trigger search ----
  chips.forEach(function(chip) {
    chip.addEventListener('click', function() {
      input.value = chip.getAttribute('data-dr-search-chip') || chip.textContent.trim();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    });
  });

  // ---- Fetch + render ----
  var cache = new Map();
  var inflight = null;
  var debounceId = null;

  function renderEmpty() {
    emptyEl.hidden = false;
    liveEl.hidden = true;
    liveEl.innerHTML = '';
  }
  function renderLoading() {
    emptyEl.hidden = true;
    liveEl.hidden = false;
    liveEl.innerHTML = '<div class="dr-search__skeleton"></div><div class="dr-search__skeleton"></div>';
  }
  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    if (typeof cents !== 'number') return '';
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function safeUrl(u) {
    var s = String(u == null ? '' : u);
    // Allow only http(s):, root-relative (/), or hash anchors. Reject javascript:, data:, vbscript:, etc.
    return /^(https?:|\/|#)/i.test(s) ? s : '#';
  }
  function renderResults(query, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var collections = r.collections || [];
    var pages = r.pages || [];
    var articles = r.articles || [];
    var total = products.length + collections.length + pages.length + articles.length;

    emptyEl.hidden = true;
    liveEl.hidden = false;

    if (total === 0) {
      liveEl.innerHTML =
        '<p class="dr-search__no-results">No matches for &ldquo;' + escapeHTML(query) + '&rdquo;.</p>';
      return;
    }

    var html = '';
    // LEFT — products
    html += '<div class="dr-search__products">';
    html += '<p class="dr-search__eyebrow">Products</p>';
    html += '<ul class="dr-search__products-list" role="list">';
    products.slice(0, 4).forEach(function(p) {
      var img = p.featured_image
        ? '<img src="' + escapeHTML(safeUrl(p.featured_image)) + '" alt="" loading="lazy" width="80" height="80">'
        : '';
      var priceCents = null;
      if (p.price && p.price.amount != null) {
        priceCents = Math.round(Number(p.price.amount) * 100);
      } else if (typeof p.price === 'number') {
        priceCents = p.price;
      } else if (p.price_min != null) {
        // Shopify suggest.json returns price_min as a string like "19.99" — coerce
        var n = Number(p.price_min);
        if (!isNaN(n)) priceCents = Math.round(n * 100);
      }
      html += '<li>' +
        '<a class="dr-search__product" href="' + escapeHTML(safeUrl(p.url)) + '" data-dr-search-item>' +
          '<span class="dr-search__product-media">' + img + '</span>' +
          '<span class="dr-search__product-body">' +
            '<span class="dr-search__product-title">' + escapeHTML(p.title) + '</span>' +
            (priceCents != null ? '<span class="dr-search__product-price">' + escapeHTML(money(priceCents)) + '</span>' : '') +
          '</span>' +
        '</a></li>';
    });
    html += '</ul></div>';

    // RIGHT — collections, pages, articles
    html += '<div class="dr-search__rest">';
    function group(label, items) {
      if (!items.length) return '';
      var s = '<div class="dr-search__group"><p class="dr-search__eyebrow">' + label + '</p>';
      s += '<ul class="dr-search__links" role="list">';
      items.slice(0, 3).forEach(function(it) {
        s += '<li><a class="dr-search__link" href="' + escapeHTML(safeUrl(it.url)) + '" data-dr-search-item>' +
             escapeHTML(it.title) + '</a></li>';
      });
      s += '</ul></div>';
      return s;
    }
    html += group('Collections', collections);
    html += group('Pages', pages);
    html += group('Articles', articles);
    html += '</div>';

    // FOOTER
    html += '<div class="dr-search__footer">' +
            '<a class="dr-search__footer-link" href="/search?q=' + encodeURIComponent(query) +
            '">See all results for &ldquo;' + escapeHTML(query) + '&rdquo; →</a></div>';

    liveEl.innerHTML = html;
  }

  function doFetch(query) {
    if (cache.has(query)) { renderResults(query, cache.get(query)); return; }
    renderLoading();
    if (inflight) inflight.abort();
    inflight = new AbortController();
    var url = '/search/suggest.json' +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,page,article' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';
    fetch(url, { signal: inflight.signal, headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function(data) { cache.set(query, data); renderResults(query, data); })
      .catch(function(err) {
        if (err && err.name === 'AbortError') return;
        console.warn('[dr-search] fetch failed', err);
        renderEmpty();
      });
  }

  input.addEventListener('input', function() {
    var q = input.value.trim();
    if (debounceId) clearTimeout(debounceId);
    if (q.length < 2) { renderEmpty(); return; }
    debounceId = setTimeout(function() { doFetch(q); }, 150);
  });

  // ---- Keyboard navigation over all visible result items ----
  function getItems() {
    // The order matters: products first, then right-column links, then trending/chips in the empty state.
    var scope = emptyEl.hidden ? liveEl : emptyEl;
    return Array.prototype.slice.call(
      scope.querySelectorAll('.dr-search__product, .dr-search__link, .dr-search__chip')
    );
  }
  var activeIdx = -1;
  function setActive(idx) {
    var items = getItems();
    items.forEach(function(el, i) {
      if (i === idx) el.setAttribute('data-active', 'true');
      else el.removeAttribute('data-active');
    });
    activeIdx = idx;
    if (items[idx]) items[idx].scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('keydown', function(e) {
    var items = getItems();
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(Math.min(activeIdx + 1, items.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      // From cold state (-1), ArrowUp jumps to the last item — matches typeahead conventions in Algolia/Slack/GitHub.
      if (activeIdx === -1) setActive(items.length - 1);
      else setActive(Math.max(activeIdx - 1, 0));
    } else if (e.key === 'Enter') {
      if (items[activeIdx]) {
        e.preventDefault();
        if (items[activeIdx].tagName === 'A') {
          window.location.href = items[activeIdx].href;
        } else {
          items[activeIdx].click();
        }
      } else if (input.value.trim().length >= 2) {
        // No item highlighted but the user pressed Enter — go to full search results
        e.preventDefault();
        window.location.href = '/search?q=' + encodeURIComponent(input.value.trim());
      }
    }
  });

  // Reset highlight whenever the visible result set changes
  var resultsObserver = new MutationObserver(function() { activeIdx = -1; });
  resultsObserver.observe(liveEl, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
